export enum ActionPromptType {
    NONE = 0,
    JOIN_DRAW_FIRST_TIME = 1,
    CREATE_BUSINESS_FIRST_TIME = 2,
    CONVERT_ENERGY_FIRST_TIME = 3,
    UPGRADE_WORK_FIRST_TIME = 4,
    PASS_QUIZ_FIRST_TIME = 5,
    COMPLETE_SUBSCRIPTION_TASK_FIRST_TIME = 6,
    UPGRADE_BUSINESS_FIRST_TIME = 7,
    PLACE_ICON_ON_DESKTOP_FIRST_TIME = 8,

    GAME_RANGE = 50,
    AVAILABLE_SUBSCRIPTION_CHANNELS = 51,

    ADDITIONAL_RANGE = 100,
    DRAWS_ADD = 101,
    OFFICE_ADD = 102,
    BUSINESS_ADD = 103,
    WORK_ADD = 104,
    UPGRADE_WORK_ADD = 105,
    TASKS_ADD = 106,
    SUBSCRIPTION_ADD = 107,
    PLACE_ICON_ADD = 108,
}
